import { gql } from '__generated__';

const DeleteExportMutation = gql(`
  mutation DeleteExport($id: ID!) {
    deleteExport(id: $id)
  }
`);

export default DeleteExportMutation;
